const pageStyle = {
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #edf4ff 0%, #f8fbff 48%, #ffffff 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '32px 16px',
};

const cardStyle = {
  width: '100%',
  maxWidth: '560px',
  background: '#ffffff',
  borderRadius: '28px',
  padding: '34px',
  boxShadow: '0 24px 70px rgba(15, 23, 42, 0.12)',
  border: '1px solid rgba(13, 46, 99, 0.08)',
};

const brandStyle = {
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: '52px', height: '52px', borderRadius: '18px', background: 'linear-gradient(135deg, #0d4fb3, #0a3d91)', color: '#fff', fontWeight: 900, fontSize: '1.05rem', marginBottom: '22px',
};

const titleStyle = { fontSize: '1.85rem', fontWeight: 900, color: '#0d2e63', margin: '0 0 10px' };
const textStyle = { color: '#607089', lineHeight: 1.7, marginBottom: '24px' };
const labelStyle = { display: 'block', fontWeight: 800, color: '#0d2e63', marginBottom: '8px', fontSize: '0.94rem' };
const inputStyle = { width: '100%', borderRadius: '14px', minHeight: '52px', border: '1px solid rgba(13, 46, 99, 0.14)', padding: '12px 14px', outline: 'none', color: '#10213a', marginBottom: '16px' };
const buttonStyle = { width: '100%', minHeight: '54px', border: 'none', borderRadius: '14px', background: 'linear-gradient(135deg, #0d4fb3, #0a3d91)', color: '#fff', fontWeight: 900, cursor: 'pointer', boxShadow: '0 18px 36px rgba(13, 79, 179, 0.20)' };
const secondaryButtonStyle = { ...buttonStyle, background: '#ffffff', color: '#0d4fb3', border: '1px solid rgba(13, 79, 179, 0.22)', boxShadow: 'none', textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' };
const alertBaseStyle = { borderRadius: '16px', padding: '14px 16px', fontWeight: 700, lineHeight: 1.55, marginBottom: '18px' };
const errorStyle = { ...alertBaseStyle, background: '#fff5f5', border: '1px solid rgba(220, 53, 69, 0.16)', color: '#b02a37' };
const successStyle = { ...alertBaseStyle, background: '#f3fff7', border: '1px solid rgba(25, 135, 84, 0.16)', color: '#146c43' };
const helperLinkStyle = { color: '#0d4fb3', fontWeight: 800, textDecoration: 'none' };

export { pageStyle, cardStyle, brandStyle, titleStyle, textStyle, labelStyle, inputStyle, buttonStyle, secondaryButtonStyle, errorStyle, successStyle, helperLinkStyle };
